// extracted by mini-css-extract-plugin
export default {"container":"DialogContent_container__OTReP","modal":"DialogContent_modal__zjc5O"};